import {
  Icon,
  Inline,
  Stack,
  Tooltip,
  Typography,
} from '@omnipresentgroup/design-system';
import type { CompensationVariantPayment } from '@omnipresentgroup/types';

export const VariantPaymentTooltip = ({
  variantPayment,
}: {
  variantPayment: CompensationVariantPayment;
}) => {
  const { id, reason, additionalNotes } = variantPayment;
  return (
    <Tooltip
      id={`reason-notes-${id}`}
      description={
        <Stack gap="4">
          <Inline gap="4">
            <Typography as="span" size="12" weight="medium" color="subtle">
              Reason:
            </Typography>
            <Typography as="span" size="12" color="subtle">
              {reason}
            </Typography>
          </Inline>
          {additionalNotes && (
            <Inline gap="4">
              <Typography as="span" size="12" weight="medium" color="subtle">
                Notes:
              </Typography>
              <Typography as="span" size="12" color="subtle">
                {additionalNotes}
              </Typography>
            </Inline>
          )}
        </Stack>
      }
    >
      <Icon icon="InfoCircle" size="16" />
    </Tooltip>
  );
};
